module.exports = __webpack_public_path__ + "img/introduction.ec9f3a3c.png";